export default __webpack_public_path__ + "static/media/logo.5b1c1c1e.png";